module.exports = __webpack_public_path__ + "static/media/pin.8b7d4e5d.svg";